var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMeetingTask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.99 12.97H16.79V17.85H11.99V12.97ZM18.72 8.08999H5.25999V6.13999H18.71V8.08999H18.72ZM18.72 19.81H5.25999V10.05H18.71V19.81H18.72ZM18.72 4.18999H17.76V2.23999H15.84V4.18999H8.14999V2.23999H6.22999V4.18999H5.26999C4.19999 4.18999 3.35999 5.06999 3.35999 6.13999V19.81C3.35999 20.88 4.20999 21.76 5.26999 21.76H18.72C19.78 21.76 20.64 20.88 20.64 19.81V6.13999C20.64 5.06999 19.78 4.18999 18.72 4.18999Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.99 12.97H16.79V17.85H11.99V12.97ZM18.72 8.08999H5.25999V6.13999H18.71V8.08999H18.72ZM18.72 19.81H5.25999V10.05H18.71V19.81H18.72ZM18.72 4.18999H17.76V2.23999H15.84V4.18999H8.14999V2.23999H6.22999V4.18999H5.26999C4.19999 4.18999 3.35999 5.06999 3.35999 6.13999V19.81C3.35999 20.88 4.20999 21.76 5.26999 21.76H18.72C19.78 21.76 20.64 20.88 20.64 19.81V6.13999C20.64 5.06999 19.78 4.18999 18.72 4.18999Z",
    fill: "#8285F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeetingTask);
export default __webpack_public_path__ + "static/media/meeting-task.2873f62d3742a0600bc404d89eb68842.svg";
export { ForwardRef as ReactComponent };